import { GlobalConfig, IndividualConfig } from 'ngx-toastr';

export const NOTIFICATIONS_INDIVIDUAL_CONFIG: Partial<IndividualConfig> = {
  closeButton: true,
  timeOut: 5000,
  progressBar: true,
  tapToDismiss: false,
};

export const NOTIFICATIONS_GLOBAL_CONFIG: Partial<GlobalConfig> = {
  maxOpened: 3,
  autoDismiss: true,
  newestOnTop: true,
  preventDuplicates: true,
  includeTitleDuplicates: true,
  resetTimeoutOnDuplicate: true,
};
